<template lang="pug">
    .page(ref='galleryPage')
      section
        .text-center
          h1 {{ `${account.user.firstname.toUpperCase()}'S COLLECTION `}}
          p Review the pieces you've loved
      masonry.gallery(:cols="{default: 4, 1000: 3, 700: 2, 400: 1}")
        .piece.m-3(v-for="piece in art", :key='piece.id')
          router-link(:to="{name: `Piece`, params: { pieceId: piece.id, pieceTitle: kebabMe(piece.title) }}")
            img.thumbnail(:src="piece.thumbnail_url", v-if="!piece.isDummy")
            .placeholder-img.bg-light(v-else="")
              b-spinner(type="grow")
          .info.p-2(v-if="!piece.isDummy")
            .row
              .col-8
                h6.text-dark {{ piece.artist }}
              .col-4.text-right
                h6.text-dark {{ `R${piece.price}` }}
            .row
              .col-10
                p.my-1.text-dark {{ piece.title }}
              .col-2.text-right(v-if="piece")
                a.favourite.love(@click="unlovePiece(piece)")
                  font-awesome-icon(icon="heart")
            .row
              .col-12
                p.m-0.small {{ `${piece.height}x${piece.width}cm | ${piece.medium}` }}
          .info.p-2(v-else="")
            .row
              .col-8
                content-loader(:height="20")
              .col-4
                content-loader(:height="40")
              .col-12
                content-loader(:height="12")
      section.text-center(v-if="!alert.loading && art.length === 0")
        img.logo(src="@/assets/images/branding/logo_icon_grey.svg")
        p.mt-5 No items
</template>

<script>
import { mapState } from 'vuex';
import standardMix from '@/mixins/standardMix';
import { apiService } from '@/services';

export default {
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
      art: [],
      dummyArt: [
        { id: 'a', isDummy: true },
        { id: 'b', isDummy: true },
        { id: 'c', isDummy: true },
        { id: 'd', isDummy: true },
      ],
      showFilter: true,
      collapsed: true,
      filter: {
        form: 'All',
        style: 'All',
        medium: 'All',
        subject: 'All',
        artist_id: 'All',
        limit: 5,
        offset: 0,
        // price_high: 0,
      },
      noMore: true,
    };
  },
  computed: {
    ...mapState('resource', ['art_forms', 'art_media', 'art_styles', 'art_subjects']),
  },
  methods: {
    async getArt(reset) {
      try {
        if (reset) {
          this.art = [];
          this.filter.offset = 0;
          this.noMore = false;
        }
        this.loading();
        this.art.push(...this.dummyArt);
        const newArt = await apiService.getLovedArt(this.profileId, this.filter);
        if (newArt.length === 0) {
          this.noMore = true;
        }
        this.art = this.art.filter(item => !item.isDummy);
        // eslint-disable-next-line no-restricted-syntax
        for (const item of newArt) {
          this.art.push(item);
        }
        this.clear();
        this.filter.offset += this.filter.limit;
      } catch (error) {
        this.error(error);
      }
    },
    async unlovePiece(piece) {
      try {
        await apiService.unlovePiece(this.profileId, piece.id);
        this.art = this.art.filter(item => item.id !== piece.id);
      } catch (error) {
        this.error('Something went wrong');
      }
    },
    onScroll() {
      const scrollBottom = document.documentElement.scrollTop + document.documentElement.clientHeight;
      const galleryHeight = this.$refs.galleryPage.clientHeight;
      if ((scrollBottom >= galleryHeight) && !this.alert.loading) {
        this.getArt();
      }
    },
  },
  watch: {
    noMore(done) {
      if (done) {
        window.removeEventListener('scroll', this.onScroll);
      } else {
        window.addEventListener('scroll', this.onScroll);
      }
    },
  },
  async created() {
    // Process route param filters
    const { form, style, medium, subject } = this.$route.params;
    this.filter.form = form || 'All';
    this.filter.medium = medium || 'All';
    this.filter.style = style || 'All';
    this.filter.subject = subject || 'All';
    this.noMore = false;
    await this.getArt();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
};
</script>

<style lang="scss" scoped>

  .gallery {
    background-color: white;
    .piece {
      opacity: 1;
      .thumbnail {
        width: 100%;
      }
      .placeholder-img {
        width: 100%;
        height: 300px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .info {
        .favourite {
          color: lightgray;
          &.love {
            // color: rgb(250, 195, 0);
            color: black;
          }
        }
      }
    }
  }
  .logo {
    width: 150px;
  }

</style>



// WEBPACK FOOTER //
// src/components/views/Love.vue